module.exports = __webpack_public_path__ + "img/mb-dark.06020db9.png";